export default {
  install(Vue, options) {
    Vue.mixin({
      created() {
        Vue.prototype.$deploymentCurrent = document.head.querySelector('meta[name="deployment-current"]').content;
      },
    });

    Vue.prototype.$deploymentIs = function (name) {
      return this.$deploymentCurrent == name;
    };

    Vue.prototype.$deploymentIn = function (names) {
      if (! Array.isArray(names)) {
        return false;
      }

      return names.includes(this.$deploymentCurrent);
    };
  },
};
